module.exports = "<div *ngIf=\"isWaiting\">\n  Waiting...\n</div>\n<div *ngIf=\"errorMessage && errorMessage.length>0\">\n{{errorMessage}}\n</div>"